import { css } from 'styled-components';
import { rem } from '../utils';
export const Default = css `
  ::-webkit-scrollbar,
  &::-webkit-scrollbar {
    width: ${({ theme }) => rem(theme.Components.Scrollbar.ThinWidth)};
  }

  ::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.Color.Neutrals.Border};
  }

  ::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${theme.Spacing.Size.MediumSmall}px;`};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.Color.Neutrals.Border} transparent;
`;
export const Panel = css `
  ::-webkit-scrollbar,
  &::-webkit-scrollbar {
    width: ${({ theme }) => rem(theme.Components.Scrollbar.NormalWidth)};
  }

  ::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.Color.Neutrals.Border};
  }

  ::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${theme.Spacing.Size.MediumSmall}px;`};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.Color.Neutrals.Border} transparent;
`;
//# sourceMappingURL=Scrollbar.js.map